const info = {
  ZH: { //中文翻译
     noResult1:"无查询结果，请确认供应商信息是否正确，或是否该企业为本企业供应商。",
     address:"联系地址",
     confirmChangeContact:"如需更换当前联系人为默认，请点击【确定】",
     confirmSetEffect:"是否确定更改有效性？",
     saveTip1:"保存后当月不可再修改，请确认是否保存。",
     createConcat:"创建本企业联系人",
     editConcat:"编辑本企业联系人",
    },
  EN: { //英文翻译
    noResult1:"No query results, please confirm if the supplier information is correct or if the company is our supplier.",
    address:"Contact address",
    confirmChangeContact:"To change the current contact to default, please click [confirm]",
    confirmSetEffect:"Are you sure about the validity of the changes?",
    saveTip1:"After saving, it cannot be modified again in the current month. Please confirm if you want to save it.",
    createConcat:"Create a contact person for this company",
    editConcat:"Edit the contact person for this company",
  }
}
export default info //需要暴露出去
